import React from 'react';
import RegisterForm from '../components/Auth/RegisterForm';
import { Container, Typography, Box } from '@mui/material';

export default function RegisterPage() {
  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Register
        </Typography>
        <RegisterForm />
      </Box>
    </Container>
  );
}
